import {
  FETCH_STATISTIC,
  SET_FILTER_STATISTIC,
  SET_STATISTIC_MANAGERS_HASH,
  SET_HISTORIES_BY_MANAGER_IDS,
  SET_COMMUNICATION_COUNTS_BY_MANAGER_IDS,
  SET_TIMES_IN_STATUSES_BY_MANAGER_IDS,
} from '../actions/statistic';

import { SET_CURRENT_MANAGER } from '../actions/general';

const initialState = {
  filters: {
    managers: [],
    date: new Date(),
  },
  managersHash: {},
  historiesByManagerId: {},
  statsByManagerId: {},
  timesByManagerId: {},
  isLoadingManagers: true,
  isLoadingHistories: true,
};

export default (state = initialState, { payload, type, error }) => {
  switch (type) {
    case FETCH_STATISTIC: {
      return {
        ...state,
        isLoadingManagers: true,
        isLoadingHistories: true,
        managersHash: {},
        historiesByManagerId: {},
        statsByManagerId: {},
        timesByManagerId: {},
      };
    }

    case SET_STATISTIC_MANAGERS_HASH: {
      return {
        ...state,
        managersHash: payload.managersHash,
        isLoadingManagers: false,
      };
    }

    case SET_HISTORIES_BY_MANAGER_IDS: {
      return {
        ...state,
        historiesByManagerId: payload.historiesByManagerId,
        isLoadingHistories: false,
      };
    }

    case SET_COMMUNICATION_COUNTS_BY_MANAGER_IDS: {
      return {
        ...state,
        statsByManagerId: payload.statsByManagerId,
      };
    }

    case SET_TIMES_IN_STATUSES_BY_MANAGER_IDS: {
      return {
        ...state,
        timesByManagerId: payload.timesByManagerId,
      };
    }

    case SET_FILTER_STATISTIC: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload,
        },
        isLoadingManagers: true,
        isLoadingHistories: true,
        managersHash: {},
        historiesByManagerId: {},
        statsByManagerId: {},
        timesByManagerId: {},
      };
    }

    case SET_CURRENT_MANAGER: {
      const { currentManager } = payload;
      const { id } = currentManager;

      return {
        ...state,
        filters: {
          ...state.filters,
          managers: [id],
        },
      };
    }

    default:
      return state;
  }
};
